import { defineMessages } from 'react-intl';

const messages = defineMessages({
  topLinkText: {
    id: 'HelpSection.TopLinkText',
    defaultMessage: 'Top',
  },
});

export default messages;
